// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    DispatchResetQuotes,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import setRequestedDeliveryDate from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetRequestedDeliveryDate";
import setRequestedPickUpDate from "@mcmc/App/Handlers/Pages/CheckoutShipping/SetRequestedPickUpDate";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";

export const UpdateCartParameter: typeof PopulateApiParameter = (props: Parameters<typeof PopulateApiParameter>[0]) => {
    if (!props.cartToUpdate) {
        return;
    }
    const state = props.getState() as McMcApplicationState;
    const notes = state.xCheckout.userDataById[props.cartToUpdate.orderNumber]?.notes;
    const fulfillmentMethod = state.context.session.fulfillmentMethod;
    props.cartToUpdate.fulfillmentMethod = fulfillmentMethod;
    if (notes && fulfillmentMethod === FulfillmentMethod.Ship) {
        props.cartToUpdate.notes = notes;
    }
};

export const ResetRequestedDates: typeof PopulateApiParameter = (props: Parameters<typeof PopulateApiParameter>[0]) => {
    props.dispatch(setRequestedDeliveryDate({ requestedDeliveryDate: undefined }));
    props.dispatch(setRequestedPickUpDate({ requestedPickUpDate: undefined }));
};

addToChainBefore(chain, PopulateApiParameter, UpdateCartParameter);
addToChainAfter(chain, DispatchResetQuotes, ResetRequestedDates);
